import SadBlip from 'assets/img/sad-blip.svg';
import ConfusedBlip from 'assets/img/confused-blip.svg';
import { CONNECT_USER_ERROR } from 'modules/messaginghub/BlipService';
export class ErrorController {
    static $inject = ['$state', '$translate', 'LoadingService'];
    constructor($state, $translate, LoadingService) {
        'ngInject';
        this.$state = $state;
        this.$translate = $translate;
        this.LoadingService = LoadingService;
    }
    async $onInit() {
        try {
            this.errorIcon = SadBlip;
            this.errorMsg = await this.$translate('errorScreen.errorMsg');
            if (this.$state.params && this.$state.params.error) {
                if (this.$state.params.error.message.includes(CONNECT_USER_ERROR)) {
                    this.errorMsg = await this.$translate('errorScreen.wsConnectErrorMsg');
                    return;
                }
                if (this.$state.params.error.message.includes('is in the past') ||
                    this.$state.params.error.message.includes('is in the future')) {
                    this.errorIcon = ConfusedBlip;
                    this.errorMsg = await this.$translate('errorScreen.hourErrorMsg');
                    return;
                }
            }
        }
        catch (e) {
            throw e;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
}
ErrorController.$inject = ['$state', '$translate', 'LoadingService'];
